import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import RoleValidations from 'scaleflow/validators/role';

export default class QuickAddsRoleComponent extends Component {
  @service store;
  @service router;
  role = {
    name: '',
  };
  roleValidations = RoleValidations;

  @action
  async onSubmit(changeset, e) {
    e.preventDefault();
    try {
      await changeset.validate();
      if (changeset.isInvalid) {
        console.debug(changeset.errors);
        return;
      }
      const role = this.store.createRecord('role', {
        name: changeset.name,
      });
      await role.save();
      this.args?.onItemSaved(role);
      this.handleModalDismiss();
    } catch (err) {
      console.log(err);
    }
  }

  @action
  handleModalDismiss() {
    this.args?.handleFormDismiss();
  }
}
